import {
  HttpClient,
  HttpClientRequest,
  HttpClientResponse,
} from "@effect/platform";
import { RestrictionsBody, RestrictionsResponse } from "@silo/data";
import { Address } from "@silo/types";
import { QueryFunction, useQuery } from "@tanstack/react-query";
import { Console, Effect, pipe } from "effect";
import { isNotNullable } from "effect/Predicate";

const restrictionsKey = "restrictions";

type RestrictionsKey = [key: typeof restrictionsKey, user: Address];

export function useQueryRestrictions(user: Address | undefined) {
  return useQuery({
    queryKey: [restrictionsKey, user!],
    queryFn: queryRestrictions,
    enabled: isNotNullable(user),
  });
}

const DEFAULT_RESTRICTIONS_RESPONSE: RestrictionsResponse = {
  isBlocked: false,
};

const queryRestrictions: QueryFunction<
  RestrictionsResponse,
  RestrictionsKey
> = async ({ queryKey: [, user] }) => {
  const body: RestrictionsBody = {
    address: user,
  };

  const result = await pipe(
    HttpClientRequest.post("/api/restrictions"),
    HttpClientRequest.setHeader("Content-Type", "application/json"),
    HttpClientRequest.jsonBody(body),
    Effect.andThen(HttpClient.fetchOk),
    Effect.andThen(HttpClientResponse.schemaBodyJson(RestrictionsResponse)),
    Effect.scoped,
    Effect.tapError((error) => Console.warn(error)),
    Effect.catchAll(() => Effect.succeed(DEFAULT_RESTRICTIONS_RESPONSE)),
    Effect.runPromise
  );

  return result;
};
